import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { convertEnglishToKorean } from '../utils/textUtils';

const KoreanConverter: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (text) {
      setResult(convertEnglishToKorean(text));
    } else {
      setResult('');
    }
  }, [text]);

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">한영 변환</h1>
          <p className="text-textSecondary">
            영타로 쓴 한글을 자동 변환합니다
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <label className="block text-textSecondary mb-8 text-sm">
            영문으로 입력된 텍스트
          </label>
          <Textarea
            value={text}
            onChange={setText}
            placeholder="예: dkssudgktpdy"
          />
        </motion.div>

        {result && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="text-center mb-16 text-2xl text-textSecondary">↓</div>
            <label className="block text-textSecondary mb-8 text-sm">
              변환 결과
            </label>
            <Textarea value={result} onChange={setResult} />
            <div className="mt-12">
              <Button onClick={handleCopy}>결과 복사</Button>
            </div>

            <div className="mt-24 p-16 bg-blue-50 rounded-medium">
              <p className="text-sm text-textSecondary">
                💡 팁: Ctrl+V로 붙여넣으면 자동으로 변환됩니다
              </p>
            </div>
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default KoreanConverter;
